/*
 GENERATED FILE - DO NOT MODIFY
 Any changes will be overwritten when `yarn svgs` is executed.
 
 Generated from: assets/arrow-down.svg
 If you need to make changes the attributes, modify the original .svg file.
 
 If you need to modify the file further, consider copying this generated file to a new location,
 or into the component that uses it. If you do this, it might make sense to remove the original .svg file, 
 or it could be regenerated the next time SVGs are generated.
*/
import * as React from 'react';
const ArrowDownIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef: any) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.1143 8.32563C8.0512 8.38186 7.95627 8.38193 7.8931 8.32576C7.4241 7.9089 5.51413 6.20943 3.11649 4.052C2.74889 3.72123 2.25407 3.52551 1.81258 3.74826C1.6171 3.8469 1.39946 3.99173 1.18184 4.20453C0.92852 4.4522 0.769323 4.69986 0.669276 4.91333C0.48975 5.29636 0.631296 5.72313 0.89202 6.05626C2.70917 8.37806 5.3136 10.6705 6.81443 11.9153C7.50837 12.4908 8.4993 12.491 9.19327 11.9155C10.6944 10.6706 13.2988 8.37773 15.1102 6.0555C15.3696 5.72296 15.5103 5.29743 15.3317 4.91536C15.2317 4.70143 15.0723 4.453 14.8182 4.20456C14.6007 3.9919 14.3833 3.84706 14.1879 3.7484C13.7463 3.5254 13.2512 3.7211 12.8834 4.0521C10.487 6.20916 8.5822 7.9085 8.1143 8.32563Z"
        fill="currentColor"
      />
    </svg>
  ),
);
export default ArrowDownIcon;
